<div class="modal fade ig-amigos-modal" id="amigosModal" tabindex="-1" aria-labelledby="amigosModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content ig-modal-shell">
      <header class="ig-modal-header">
        <div class="ig-modal-heading">
          <span class="ig-heading-icon"><i class="fa-solid fa-user-group" aria-hidden="true"></i></span>
          <div>
            <h2 id="amigosModalLabel">Amigos y solicitudes</h2>
            <p>Conecta con las personas y mascotas de iGuau.</p>
          </div>
        </div>
        <button type="button" class="ig-close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </header>

      <div class="ig-modal-stats" *ngIf="loadamigos && !errorCarga">
        <span><i class="fa-solid fa-heart" aria-hidden="true"></i> {{activos}} {{activos === 1 ? 'amistad' : 'amistades'}}</span>
        <span *ngIf="pendientes" class="ig-pending-total"><i class="fa-solid fa-envelope-open-text" aria-hidden="true"></i> {{pendientes}} {{pendientes === 1 ? 'solicitud' : 'solicitudes'}}</span>
        <div class="ig-search-inline" *ngIf="amigos.length">
          <div class="ig-search-box">
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            <input id="ig-amigos-buscar" type="search" class="ig-search-input"
                   [value]="busqueda" (input)="busqueda = $any($event.target).value"
                   placeholder="Buscar amigos..." autocomplete="off"
                   aria-label="Buscar por nombre, mascota o localidad" />
            <button *ngIf="busqueda" type="button" class="ig-search-clear"
                    (click)="busqueda = ''" aria-label="Borrar búsqueda" title="Borrar búsqueda">
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
          <span class="ig-search-count" aria-live="polite" *ngIf="busqueda.trim()">{{amigosFiltrados.length}} resultados</span>
        </div>
      </div>

      <div class="modal-body ig-modal-body">
        <div *ngIf="!loadamigos" class="ig-feedback" role="status">
          <span class="spinner-border" aria-hidden="true"></span>
          <strong>Cargando amigos...</strong>
          <span>Estamos preparando tus contactos.</span>
        </div>

        <div *ngIf="loadamigos && errorCarga" class="ig-feedback" role="alert">
          <i class="fa-solid fa-circle-exclamation ig-state-icon" aria-hidden="true"></i>
          <strong>No se pudieron cargar tus amigos</strong>
          <span>Comprueba la conexión y vuelve a intentarlo.</span>
          <button type="button" class="ig-action primary" (click)="getAmigos()">Reintentar</button>
        </div>

        <div *ngIf="loadamigos && !errorCarga && !amigos.length" class="ig-feedback">
          <i class="fa-solid fa-paw ig-state-icon" aria-hidden="true"></i>
          <strong>Aún no tienes amigos</strong>
          <span>¡Hora de sacar las patitas y saludar!</span>
        </div>

        <div *ngIf="loadamigos && !errorCarga && amigos.length && !amigosFiltrados.length" class="ig-feedback ig-no-results">
          <i class="fa-solid fa-magnifying-glass ig-state-icon" aria-hidden="true"></i>
          <strong>No encontramos coincidencias</strong>
          <span>Prueba con otro nombre, mascota o localidad.</span>
          <button type="button" class="ig-action outline" (click)="busqueda = ''">Limpiar búsqueda</button>
        </div>

        <div class="ig-friends-grid" *ngIf="loadamigos && !errorCarga && amigos.length">
          <article class="ig-friend-card" *ngFor="let amigo of amigosFiltrados; trackBy: trackByAmigo">
            <button type="button" class="ig-friend-info" (click)="irPerfil(amigo)" [disabled]="!amigo.slug" [attr.aria-label]="'Ver perfil de ' + (amigo.first_name || 'usuario')">
              <span class="ig-avatar-group">
                <img *ngIf="amigo?.foto_mascota_thumb" class="ig-pet-avatar" [src]="amigo.foto_mascota_thumb" alt="" loading="lazy" />
                <img *ngIf="amigo?.foto?.foto_principal_thumb" class="ig-owner-avatar" [src]="amigo.foto.foto_principal_thumb" alt="" loading="lazy" />
                <span *ngIf="!amigo?.foto_mascota_thumb && !amigo?.foto?.foto_principal_thumb" class="ig-fallback"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
              </span>
              <span class="ig-friend-text">
                <strong>{{amigo?.mascota?.ma_nombre ? (amigo.mascota.ma_nombre | firstWord) + ' y ' : ''}}{{amigo.first_name | firstWord}}</strong>
                <span class="ig-detail" *ngIf="amigo?.mascota?.ma_sexo || amigo?.mascota?.edad">{{amigo?.mascota?.ma_sexo}} {{amigo?.mascota?.edad}}</span>
                <span class="ig-detail" *ngIf="amigo?.sexo || amigo?.edad">{{amigo?.sexo}} {{amigo?.edad}}</span>
                <span class="ig-detail" *ngIf="amigo?.ciudad"><i class="fa-solid fa-location-dot" aria-hidden="true"></i> {{amigo.ciudad}}</span>
              </span>
              <i class="fa-solid fa-chevron-right ig-chevron" aria-hidden="true"></i>
            </button>
            <div class="ig-card-bottom">
              <span class="ig-when"><i class="fa-regular fa-clock" aria-hidden="true"></i> {{amigo.se_fechahora | cuandoFechas}}</span>
              <span class="ig-tag pending" *ngIf="amigo.se_estado === 'pendiente'"><i class="fa-solid fa-hourglass-half" aria-hidden="true"></i> Pendiente</span>
              <span class="ig-tag active" *ngIf="amigo.se_estado === 'activo'"><i class="fa-solid fa-check" aria-hidden="true"></i> Amigos</span>
            </div>
            <div class="ig-card-actions">
              <button type="button" class="ig-action primary" *ngIf="amigo.se_estado === 'pendiente'" (click)="aceptarAmigo(amigo)" [disabled]="amigo.busy > 0">
                <span *ngIf="amigo.busy" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <i *ngIf="!amigo.busy" class="fa-solid fa-check" aria-hidden="true"></i> Aceptar solicitud
              </button>
              <button type="button" class="ig-action outline" *ngIf="amigo.se_estado === 'activo'" (click)="cancelarAmigo(amigo)" [disabled]="amigo.busy > 0">
                <span *ngIf="amigo.busy" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <i *ngIf="!amigo.busy" class="fa-solid fa-user-minus" aria-hidden="true"></i> Dejar de seguir
              </button>
            </div>
          </article>
        </div>
      </div>
      <footer class="ig-modal-footer">
        <button type="button" class="ig-footer-close" data-bs-dismiss="modal" (click)="reload()">Cerrar</button>
      </footer>
    </div>
  </div>
</div>
